import * as React from 'react';
const Anchor = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-anchor", ...props },
    React.createElement("circle", { cx: "12", cy: "5", r: "3" }),
    React.createElement("line", { x1: "12", y1: "22", x2: "12", y2: "8" }),
    React.createElement("path", { d: "M5 12H2a10 10 0 0 0 20 0h-3" })));
export default Anchor;
//# sourceMappingURL=Anchor.js.map